export const NAVIGATION_EVENTS = {
  tabPressed: 'nav_tab_pressed',
  screenViewed: 'nav_screen_viewed',
  pageViewed: 'nav_page_viewed',
  backPressed: 'nav_back_pressed',
  linkClicked: 'nav_link_clicked',
  deepLinkOpened: 'nav_deep_link_opened',
} as const;

export type NavigationEventNameType = (typeof NAVIGATION_EVENTS)[keyof typeof NAVIGATION_EVENTS];
